import axios, {AxiosRequestConfig} from "axios";
import {IWordpressAll, IWordpressBlog, IWordpressTracking} from "./InterfacesWordpress";
import {prepareOrder} from "../../services/content/functions";
import {IAPIDalli, IAPITracking, ITariff} from "./Interfaces";
import {StubTrackingInfo} from "../../pages/PageTracking/constants";

const {REACT_APP_URL_API_WP} = process.env;

const defaultArray = (obj?: { [key: string]: any }, key: string = 'items') => {
  if (!obj) {
    return;
  }
  if (!obj[key]) {
    obj[key] = [];
  }
}

class APIRequestsWordpress {
  axiosConfig: AxiosRequestConfig = {
    baseURL: `${REACT_APP_URL_API_WP}/wp-json`,
    responseType: 'json',
    headers: {
      'Content-Type': 'application/json'
    }
  }

  axiosInstance = axios.create(this.axiosConfig);

  getAll = async (): Promise<IWordpressAll> => {
    console.log('getAll');
    const response = await this.axiosInstance.get('/dalli/options');
    const data = response.data;
    console.log('getAll response', data);
    // default values for empty arrays
    defaultArray(data.advantage_slider, 'slides');
    defaultArray(data.blog, 'articles');
    defaultArray(data.company_logos, 'items');
    defaultArray(data.reviews, 'items');
    defaultArray(data.vacancies, 'items');
    defaultArray(data.stories, 'items');
    defaultArray(data.text_cards, 'items');
    return data;
  }

  getBlog = async (): Promise<IWordpressBlog> => {
    const response = await this.axiosInstance.get('/dalli/blog');
    return response.data;
  }

  getBlogMain = async (): Promise<IWordpressBlog> => {
    const response = await this.axiosInstance.get('/dalli/blog_main');
    return response.data;
  }

  sendForm = async (formId: number | string, data: { [key: string]: any }, token = ''): Promise<any> => {
    const formData = new FormData();
    Object.keys(data).forEach((key) => {
      let value = data[key];
      let fieldKey = key;

      if (key === 'name') {
        fieldKey = 'username';
      }

      // Skip null or undefined values
      if (value === null || value === undefined) {
        return;
      }

      // File objects are appended directly
      if (value instanceof File) {
        formData.append(fieldKey, value, value.name);
      } else {
        formData.append(fieldKey, value);
      }
    });
    formData.append('_wpcf7_unit_tag', `wpcf7-f${formId}-o1`);
    if (token) {
      formData.append('_wpcf7_recaptcha_response', token);
    }
    console.debug('submitting form', data);
    const response = await this.axiosInstance.post(`/contact-form-7/v1/contact-forms/${formId}/feedback`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      }
    });
    console.debug('backend response', response.data)
    return response;
  }

  tracking = async (data: { track: string; phone: string }): Promise<IAPITracking> => {
    const response = await this.axiosInstance.post<IWordpressTracking>('/dalli/tracking', data, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
    const d = response.data;
    if (d.tracking) {
      return {
        tracking: {
          number: d.tracking.number,
          company: d.tracking.company,
          date: d.tracking.date,
          invoice: d.tracking.invoice,
          town: d.tracking.town,
          statushistory: d.tracking.statushistory
        }
      };
    } else {
      return {errormsg: d.errormsg, tracking: StubTrackingInfo};
    }
  }

  getTariff = async (data: ITariff): Promise<IAPIDalli> => {
    const response = await this.axiosInstance.post<IAPIDalli>(`/dalli/deliverycost`, data, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  }

  getContentByPage = async (pageName: string): Promise<any> => {
    const response = await this.axiosInstance.get(`/dalli/content?name=${pageName}`);
    const data = response.data;
    const order = prepareOrder(data);
    return {...data, order};
  }

}

export const APIWordpress = new APIRequestsWordpress();
